import { Actions, Button, Heading, Stack, Text } from 'braid-design-system';
import React from 'react';

import { enterLocalAdminSession } from '#src/utils/localAdmin';

type LocalAdminLoginProps = {
  onAuthenticated: () => void;
};

export const LocalAdminLogin = ({ onAuthenticated }: LocalAdminLoginProps) => (
  <Stack space="large">
    <Heading level="1">Admin</Heading>
    <Text>
      Local demo mode uses in-memory sample data. Changes are not saved and
      reset when you refresh the page.
    </Text>
    <Actions>
      <Button
        tone="formAccent"
        onClick={() => {
          enterLocalAdminSession();
          onAuthenticated();
        }}
      >
        Continue as local Super Admin
      </Button>
    </Actions>
  </Stack>
);
